export default __webpack_public_path__ + "05985164d29618eb99655c3121fc9a08.png";